<template>
  <div data-component-group="pins-dialog" data-component="edit">
    <dialog-edit
      v-if="activePin && activePin.id"
      :title="`${$t('pin')} ${activePin.id}`"
      icon="gps_fixed"
      :copy-link="copyLink"
      content-class="edit-pin-dialog"
      :is-on="true"
      is-fullscreen
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-pins-edit
          :is-loading="isEditingPin"
          :is-removing="isRemovingPin"
          :on-cancel="onCancel"
          :on-submit="updatePin"
          :on-remove="removePin"
        />
      </template>
    </dialog-edit>
  </div>
</template>

<script>
  import fetchIfNotInStore from '@/mixins/fetchIfNotInStore';

  export default {
    mixins: [fetchIfNotInStore],
    emits: ['saved'],
    data() {
      return {
        isEditingPin: false,
        isRemovingPin: false,
        isLoadingPin: false,
      };
    },
    async created() {
      this.isLoadingPin = true;
      try {
        const pin = await this.fetchIfNotInStore(
          parseInt(this.$route.params.id),
          'pins',
          'items',
          'getItem',
        );
        await this.$store.dispatch('pins/setActiveItem', pin);
      } catch (err) {
        this.onCancel();
      } finally {
        this.isLoadingPin = false;
      }
    },
    computed: {
      activePin() {
        return this.$store.getters['pins/activeItem'];
      },
      parentRoute() {
        return this.$route.matched[0]?.name || 'pins';
      },
      copyLink() {
        if (this.activePin?.country?.code && this.activePin?.id) {
          return `/pins/${this.activePin.country.code}/${this.activePin.id}`;
        }
        return '/pins';
      },
    },
    methods: {
      async fetchSingleItem(id) {
        return this.$store.dispatch('pins/getItem', { id });
      },
      onCancel() {
        this.$router.push({ name: this.parentRoute, query: this.$route.query });
      },
      updatePin(pin) {
        const query = {
          ...pin,
          id: this.activePin.id,
        };

        this.isEditingPin = true;

        return this.$store
          .dispatch('pins/updateItem', query)
          .then((res) => {
            this.$emit('saved');
            this.$router.push({ name: this.parentRoute, query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isEditingPin = false;
          });
      },
      removePin(country) {
        const query = {
          id: this.activePin.id,
          country,
        };

        this.isRemovingPin = true;

        return this.$store
          .dispatch('pins/removeItem', query)
          .then((res) => {
            this.$router.push({ name: this.parentRoute, query: this.$route.query });
            return res;
          })
          .catch((err) => err)
          .finally(() => {
            this.isRemovingPin = false;
          });
      },
    },
  };
</script>
